import { render } from "./Headline.vue?vue&type=template&id=852b4086&scoped=true"
import script from "./Headline.vue?vue&type=script&lang=js"
export * from "./Headline.vue?vue&type=script&lang=js"

import "./Headline.vue?vue&type=style&index=0&id=852b4086&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-852b4086"]])

export default __exports__